export const CONTACT_US_TYPE = {
  LEARNER: "LEARNER",
  TUTOR: "TUTOR",
  GUEST: "GUEST",
  PARTNERSHIP: "PARTNERSHIP",
  GROUP_COURSE: "GROUP_COURSE",
};

export const CONTACT_US_TYPE_OPTIONS = [
  { code: CONTACT_US_TYPE.LEARNER, labelKey: "common_ns:COMMON_ITEMS.CONTACT_US_TYPE.LEARNER" },
  { code: CONTACT_US_TYPE.TUTOR, labelKey: "common_ns:COMMON_ITEMS.CONTACT_US_TYPE.TUTOR" },
  { code: CONTACT_US_TYPE.PARTNERSHIP, labelKey: "common_ns:COMMON_ITEMS.CONTACT_US_TYPE.PARTNERSHIP" },
  { code: CONTACT_US_TYPE.GROUP_COURSE, labelKey: "common_ns:COMMON_ITEMS.CONTACT_US_TYPE.GROUP_COURSE" },
];

export const CONTACT_US_CATEGORY_OPTIONS = [
  { code: "LEARNING_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.LEARNING_RELATED" },
  { code: "PAYMENT_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.PAYMENT_RELATED" },
  { code: "INSTRUCTOR_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.INSTRUCTOR_RELATED" },
  { code: "CONTENT_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.CONTENT_RELATED" },
  { code: "AI_CHATBOT_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.AI_CHATBOT_RELATED" },
  { code: "TEST_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.TEST_RELATED" },
  { code: "DASHBOARD_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.DASHBOARD_RELATED" },
  { code: "INSTRUCTOR_APPLICATION_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.INSTRUCTOR_APPLICATION_RELATED" },
  { code: "PACKAGE_EVENT_RELATED", labelKey: "UMBRACO_LANDING.CONTACT_US_CATEGORY.PACKAGE_EVENT_RELATED" },
];
